import script from "./BaseCard2.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCard2.vue?vue&type=script&setup=true&lang=js"

import "./BaseCard2.vue?vue&type=style&index=0&id=3122b84f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3122b84f"]])

export default __exports__